import { Link } from 'react-router-dom';
import './Navigation.css';

/**
 * Breadcrumb navigation component.
 *
 * @param {Object} props
 * @param {Array} props.items - Breadcrumb items
 * @param {string} props.items[].label - Display text
 * @param {string|null} props.items[].to - Route path (null = current page, no link)
 * @param {string} [props.className] - Additional CSS classes
 *
 * @example
 * <Breadcrumbs items={[
 *   { label: 'Validare', to: '/validation-hub' },
 *   { label: 'Emitenți', to: '/clients' },
 *   { label: 'Client ABC', to: null }  // Current page
 * ]} />
 *
 * Renders: Validare > Emitenți > Client ABC
 */
function Breadcrumbs({ items, className = '' }) {
  if (!items || items.length === 0) return null;

  return (
    <nav className={`nav-breadcrumbs ${className}`.trim()} aria-label="Breadcrumb">
      <ol className="nav-breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isCurrent = item.to === null || isLast;

          return (
            <li key={index} className="nav-breadcrumb-item">
              {index > 0 && (
                <span className="nav-breadcrumb-separator" aria-hidden="true">
                  ›
                </span>
              )}
              {isCurrent || !item.to ? (
                <span
                  className="nav-breadcrumb-current"
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="nav-breadcrumb-link">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
